import React, { useEffect, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { openPdfToUrl } from "../../utils/util";
import { getPatientCertificatesUrl } from "../../services/liferay/escortLeave";

const EscortCertificateModal = ({
  show,
  onClose,
  content,
  translationMap,
  onViewCertificate,
  data,
  isMobile
}) => {
  const [certificateUrl, setCertificateUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCertificate = async () => {
      try {
        setIsLoading(true);
        const result = await getPatientCertificatesUrl(content?.id || 0);


        const dataUrl = openPdfToUrl(result.data);
        setCertificateUrl(dataUrl);
      } catch (error) {
        console.error("Error fetching certificate:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (content?.id) {
      fetchCertificate();
    } else {
      console.warn("No content ID provided to fetch certificate.");
    }
  }, [content]);

  if (!show) return null;

  return (
    <div
      className={`modal fade Custom_Modal_Box show${isMobile ? " documentpdfmodal-mobileapp" : ""}`}
      id="documentpdfmodal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      style={{ display: "block" }}>
      
            <div className="modal-dialog  CoveragePlan_Dialog1" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="Title_Inner_Box">
              <span className="material-symbols-outlined">
                radio_button_unchecked
              </span>
                            <h6 className="MainTitleOne">
                                {translationMap?.escort_leave_certificate}
                            </h6>
                        </div>
                    </div>
                    <div className="modal-body" style={{ direction: "ltr" }}>
                        {isLoading ?
            <div>{translationMap?.loading}</div> :

            <Worker
              style={{ height: "auto" }}
              workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
              
                                <Viewer
                fileUrl={
                certificateUrl ?
                `${certificateUrl}` :
                `${translationMap?.loading}`
                } />

                            </Worker>
            }
                    </div>
                    <div className="modal-footer modal_footer_btn_box escort_footer_buttons">
                        <button
              type="button"
              className="btn bluetrans_btn_link"
              data-dismiss="modal"
              onClick={onClose}>
              
                            {translationMap?.goBack}
                        </button>
                        <div className="button2 button3">
                            <button onClick={(e) => onViewCertificate(data, "download", e)}>
                                <div className="content">
                  <span className="button-text">
                    {translationMap?.download}
                  </span>
                                    <i className="fa-solid fa-download"></i>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>);

};

export default EscortCertificateModal;